import { useEffect, useRef, useState } from 'react'

/** Holds a value still while it is being typed. The key is serialised so an
 *  object of form fields can be debounced as one thing; a ref carries the
 *  latest value so the timer always fires with what is on screen now. */
export function useDebounced<T>(value: T, ms: number): T {
  const key = JSON.stringify(value)
  const latest = useRef(value)
  latest.current = value
  const [out, setOut] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setOut(latest.current), ms)
    return () => clearTimeout(t)
  }, [key, ms])
  return out
}
